import { render } from "./RegisterCmp.vue?vue&type=template&id=352f806c&scoped=true"
import script from "./RegisterCmp.vue?vue&type=script&lang=js"
export * from "./RegisterCmp.vue?vue&type=script&lang=js"

import "./RegisterCmp.vue?vue&type=style&index=0&id=352f806c&scoped=true&lang=css"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-352f806c"]])

export default __exports__